const KEY_PREFIX = 'vms_integrity_modal_dismissed_until_';

const buildKey = (mail: string) => `${KEY_PREFIX}${mail}`;

export function getDismissUntil(mail: string): Date | null {
  try {
    const raw = window.localStorage.getItem(buildKey(mail));
    if (!raw) return null;
    const date = new Date(raw);
    if (Number.isNaN(date.getTime())) return null;
    return date;
  } catch {
    return null;
  }
}

export function shouldShow(mail: string): boolean {
  const until = getDismissUntil(mail);
  if (!until) return true;
  return Date.now() >= until.getTime();
}

export function setDismissForDays(mail: string, days: number): void {
  try {
    const until = new Date(Date.now() + days * 24 * 60 * 60 * 1000);
    window.localStorage.setItem(buildKey(mail), until.toISOString());
  } catch {
    /* noop: localStorage 不可用时本会话不再弹（gate 自身的 deps 限制） */
  }
}
